import Typography from 'antd/es/typography';

const { Title, Paragraph } = Typography;

export const HomePage = () => {
  return (
    <div>
      <Title level={2}>Welcome to the Platform</Title>
      <Paragraph>
        This is the platform dashboard. Navigate using the menu to access
        different features.
      </Paragraph>
    </div>
  );
};
